import { useAtomValue } from 'jotai';
import { type ReactElement } from 'react';

import { useDraftActions } from '../hooks/useDraftActions';
import { draftStatsAtom } from '../state/draftAtoms';
import DraftStatsPanel from './DraftStatsPanel';

export default function DraftBetweenPacks(): ReactElement {
  const { session, continueDraft } = useDraftActions();
  const stats = useAtomValue(draftStatsAtom);

  if (!session) return <div />;

  // currentPackIndex has already been advanced to the next pack
  const completedPackNumber = session.currentPackIndex;
  const nextPackNumber = session.currentPackIndex + 1;

  return (
    <div className="mx-auto flex h-full max-w-lg flex-col items-center justify-center gap-6 px-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-zinc-100">Pack {completedPackNumber} Complete</h2>
        <p className="mt-1 text-sm text-zinc-400">You&apos;ve drafted {session.playerPool.length} cards so far</p>
      </div>

      <div className="w-full max-w-xs rounded-lg border border-zinc-700 bg-zinc-800/50 p-4">
        <DraftStatsPanel stats={stats} />
      </div>

      <button
        onClick={continueDraft}
        className="rounded-lg bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-500"
      >
        Open Pack {nextPackNumber}
      </button>
    </div>
  );
}
